import { VariablesContentCombinedProps } from './types';

const usePresenter = (props: VariablesContentCombinedProps): VariablesContentCombinedProps => {
  return props;
};

export default usePresenter;
